<template>
  <div>
    <MonacoEditor
      v-model="model.$model"
      class="editor"
      :options="options"
      :language="lang"
      @editorDidMount="editorDidMount"
    />

    <p class="editor-error">
      <span>{{ model.$error }}&nbsp;</span>
    </p>
  </div>
</template>

<script>
import MonacoEditor from 'vue-monaco';

// @vuese
// Edytor kodu
// @group Components/Forms
export default {
  components: { MonacoEditor },
  props: {
    // Schema przekazana do komponentu
    model: {
      type: Object,
      required: true
    },
    // Wsparcie dla języka w edytorze
    lang: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      options: {
        minimap: {
          enabled: false
        }
      }
    };
  },
  methods: {
    editorDidMount(editor) {
      editor.onDidFocusEditorText(e => {
        this.model.$hasFocus = true;
      });
      editor.onDidBlurEditorText(e => {
        this.model.$hasFocus = false;
      });
    }
  }
};
</script>

<style scoped>
.editor {
  width: 100%;
  height: 300px;
}
.editor-error {
  color: red;
}
</style>
